import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <div className="py-24 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found | 1st Nations Security" description="The page you are looking for does not exist." path="/404/" />
      <h1 className="font-heading text-4xl font-bold text-white mb-4">Page Not Found</h1>
      <p className="text-gray-400 mb-8">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center gap-2 bg-[#FF9100] hover:bg-[#FF5500] text-[#0D0E11] font-bold px-6 py-3 rounded-full transition-colors">
        Back to Home
      </Link>
    </div>
  );
}
